<div class="modal-content">
    <div class="modal-header">
      <h1 class="modal-title-new pull-left" aria-hidden="true" id="my-modal-title">{{'LPR_EXEMPTION_MODAL_TITLE' | globalTranslate}}</h1>
      <button type="button" class="btn-close pull-right" [attr.aria-label]="'CLOSE' | globalTranslate" (click)="onCancel()">
        <img src="../../assets/images/⚛️ icons-close-circle-outline.svg" alt="close-icon"/>
      </button>
    </div>
    <div class="modal-body">
      <p>{{'LPR_EXEMPTION_INTRO' | globalTranslate}}</p>
      <ul>
        <li>
          {{'LPR_EXEMPTION_HUMANITARIAN' | globalTranslate}}
          <ul>
            <li>{{'LPR_EXEMPTION_REFUGEE' | globalTranslate}}</li>
            <li>{{'LPR_EXEMPTION_CUBAN_HAITIAN' | globalTranslate}}</li>
            <li>{{'LPR_EXEMPTION_DEPORTATION' | globalTranslate}}</li>
            <li>{{'LPR_EXEMPTION_AMERASIAN' | globalTranslate}}</li>
            <li>{{'LPR_EXEMPTION_AFGHAN_IRAQI' | globalTranslate}}</li>
            <li>{{'LPR_EXEMPTION_AFGHAN_IRAQI_SPOUSE' | globalTranslate}}</li>
            <li>
              {{'LPR_EXEMPTION_UKRAINIAN' | globalTranslate}}
              <ul>
                <li>{{'LPR_EXEMPTION_UKRAINIAN_SPOUSE' | globalTranslate}}</li>
                <li>{{'LPR_EXEMPTION_UKRAINIAN_PARENT' | globalTranslate}}</li>
              </ul>
            </li>
          </ul>
        </li>
        <li>
          {{'LPR_EXEMPTION_MILITARY' | globalTranslate}}
          <ul>
            <li>{{'LPR_EXEMPTION_MILITARY_FAMILY' | globalTranslate}}</li>
          </ul>
        </li>
        <li>{{'LPR_EXEMPTION_TRAFFICKING' | globalTranslate}}</li>
        <li>{{'LPR_EXEMPTION_AMERICAN_INDIAN' | globalTranslate}}</li>
        <li>{{'LPR_EXEMPTION_TRIBAL_MEMBER' | globalTranslate}}</li>
      </ul>
    </div>
  </div>